import {
    CUSTOMER_LOGIN_REQUESTED,
    CUSTOMER_LOGIN_SUCCESS,
    CUSTOMER_LOGIN_FAILED,
    CUSTOMER_LOGOUT,
    CUSTOMER_ME_SUCCESS,
    CUSTOMER_CALL_REQUESTS_FETCH_REQUESTED,
    CUSTOMER_CALL_REQUESTS_FETCH_SUCCESS,
    CUSTOMER_CALL_REQUESTS_FETCH_FAILED,
    CUSTOMER_PURCHASE_ORDERS_FETCH_REQUESTED,
    CUSTOMER_PURCHASE_ORDERS_FETCH_SUCCESS,
    CUSTOMER_PURCHASE_ORDERS_FETCH_FAILED,
} from '../actions/types';

import { getCustomerSession } from '../apis/customerSession';

const storedSession = getCustomerSession();

const INITIAL_STATE = {
    customer: storedSession ? storedSession.customer : null,
    isLoggingIn: false,
    callRequests: [],
    isFetchingCallRequests: false,
    purchaseOrders: [],
    isFetchingPurchaseOrders: false,
};

const customerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // Login / session
        case CUSTOMER_LOGIN_REQUESTED:
            return {
                ...state,
                isLoggingIn: true,
            };
        case CUSTOMER_LOGIN_SUCCESS:
        case CUSTOMER_ME_SUCCESS:
            return {
                ...state,
                customer: action.payload,
                isLoggingIn: false,
            };
        case CUSTOMER_LOGIN_FAILED:
            return {
                ...state,
                isLoggingIn: false,
            };
        case CUSTOMER_LOGOUT:
            return {
                ...state,
                customer: null,
                callRequests: [],
                purchaseOrders: [],
            };
        // History
        case CUSTOMER_CALL_REQUESTS_FETCH_REQUESTED:
            return {
                ...state,
                isFetchingCallRequests: true,
            };
        case CUSTOMER_CALL_REQUESTS_FETCH_SUCCESS:
            return {
                ...state,
                callRequests: action.payload,
                isFetchingCallRequests: false,
            };
        case CUSTOMER_CALL_REQUESTS_FETCH_FAILED:
            return {
                ...state,
                isFetchingCallRequests: false,
            };
        case CUSTOMER_PURCHASE_ORDERS_FETCH_REQUESTED:
            return {
                ...state,
                isFetchingPurchaseOrders: true,
            };
        case CUSTOMER_PURCHASE_ORDERS_FETCH_SUCCESS:
            return {
                ...state,
                purchaseOrders: action.payload,
                isFetchingPurchaseOrders: false,
            };
        case CUSTOMER_PURCHASE_ORDERS_FETCH_FAILED:
            return {
                ...state,
                isFetchingPurchaseOrders: false,
            };
        default:
            return state;
    }
};

export default customerReducer;
